import { render, staticRenderFns } from "./ControlPagos.vue?vue&type=template&id=faaebd84&"
import script from "./ControlPagos.vue?vue&type=script&lang=js&"
export * from "./ControlPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports